import React, { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle";
import { displayFormatDate, toggleMenu } from "../../utils/helpers";
import SortableTable from "../../components/SortableTable";
import { ThreeDots, TailSpin } from "react-loader-spinner";
import Cookies from "js-cookie";
import { formatDate } from "../../utils/helpers";
import { getApi } from "../../utils/api";
import {
  API_ACCESS_EMPLOYEE_DATA,
  API_DOWNLOAD_ACCESS_REPORT,
  API_GET_ACCESS_TYPES,
  EMPLOYEE_LIST,
} from "../../config/Endpoints";
import { toast } from "react-toastify";
import Select from "react-select";
import NoRecordsAvailable from "../../components/NoRecordsAvailable";
import Badge from "../../components/Badge";

const DownloadAccessReport = ({ title, description }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingExport, setLoadingExport] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [loadingEmployees, setLoadingEmployees] = useState(true);

  const [selectedAccessType, setSelectedAccessType] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const accessToken = Cookies.get("accessToken");
  const [employees, setEmployees] = useState([]);
  const [accessTypes, setAccessTypes] = useState([]);
  const [roles, setRoles] = useState([]);
  const statusOptions = [
    { label: "Approved", value: "APPROVED" },
    { label: "Pending", value: "PENDING" },
    { label: "Deallocated", value: "DEALLOCATED" },
    { label: "Rejected", value: "REJECTED" },
  ];

  const columns = [
    { key: "fullName", label: "Employee Name", sortable: true },
    { key: "accessName", label: "Access Type", sortable: true },
    { key: "userRole", label: " Role", sortable: true },
    {
      key: "projectName",
      label: "Project Name",
      sortable: true,
      render: (row) => (row.projectName ? row.projectName : "All Projects"),
    },
    {
      key: "requestedStartDate",
      label: "Requested Start Date",
      sortable: true,
      render: (row) =>
        row.requestedStartDate
          ? displayFormatDate(row.requestedStartDate)
          : "-",
    },
    {
      key: "requestedEndDate",
      label: "Requested End Date",
      sortable: true,
      render: (row) =>
        row.requestedEndDate
          ? displayFormatDate(row.requestedEndDate)
          : "Ongoing",
    },
    {
      key: "accessStartDate",
      label: "Actual Start Date",
      sortable: true,
      render: (row) =>
        row.accessStartDate ? displayFormatDate(row.accessStartDate) : "-",
    },
    {
      key: "accessEndDate",
      label: "Actual End Date",
      sortable: true,
      render: (row) =>
        row.accessEndDate ? displayFormatDate(row.accessEndDate) : "-",
    },
    {
      key: "status",
      label: "Status",
      sortable: true,
      render: (row) => {
        let status = row.status || "-";

        const label =
          status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();

        const badgeClass =
          status === "PENDING"
            ? "warning"
            : status === "APPROVED" || status === "ALLOCATED"
            ? "success"
            : status === "REJECTED"
            ? "danger"
            : status === "DEALLOCATED"
            ? "secondary"
            : "secondary";

        return <Badge type={badgeClass}>{label}</Badge>;
      },
    },

    // { key: "deliveryLead", label: "Delivery Lead", sortable: true },
  ];

  const handleFilter = async () => {
    setLoading(true);

    try {
      const params = new URLSearchParams();

      if (selectedStatus) params.append("status", selectedStatus);
      if (selectedEmployee) params.append("employeeId", selectedEmployee.value);
      if (selectedAccessType)
        params.append("accessType", selectedAccessType.value);
      if (selectedRole) params.append("userRole", selectedRole.value);

      const url = `${API_ACCESS_EMPLOYEE_DATA}V2?${params.toString()}`;

      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const json = await res.json();
      setData(json.data || []);
    } catch (err) {
      console.error("Filter error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchEmployees = async () => {
      setLoadingEmployees(true);
      try {
        const res = await getApi(EMPLOYEE_LIST, accessToken);
        const employeeData = res?.data?.data || [];
        console.log(employeeData);
        const empOptions = employeeData.map((emp) => ({
          value: emp.id,
          label: emp.empName,
        }));

        setEmployees(empOptions);
      } catch (error) {
        setEmployees([]);
      } finally {
        setLoadingEmployees(false);
      }
    };

    fetchEmployees();
  }, []);

  useEffect(() => {
    const fetchAccessTypes = async () => {
      try {
        const res = await getApi(
          `${API_GET_ACCESS_TYPES}?status=APPROVED`,
          accessToken
        );

        const accessTypesData = res?.data?.data?.accessTypes || [];
        const accessSubtypesData = res?.data?.data?.accessSubtypes || [];

        // Access Types dropdown values
        const types = accessTypesData.map((at) => ({
          value: at.accessId,
          label: at.name,
          isRole: at.isRole,
        }));

        // Roles dropdown (subtypes)
        const roleOptions = accessSubtypesData.map((sub) => ({
          value: sub,
          label: sub,
        }));

        setAccessTypes(types);
        setRoles(roleOptions);
      } catch (error) {
        setAccessTypes([]);
        setRoles([]);
      }
    };

    fetchAccessTypes();
  }, []);

  useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     const res = await fetch(`${API_ACCESS_EMPLOYEE_DATA}V2`, {
    //       method: "GET",
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${accessToken}`,
    //       },
    //     });
    //     const json = await res.json();
    //     setData(json.data || []);
    //   } catch (error) {
    //     console.error("Error fetching access report:", error);
    //   } finally {
    //     setLoading(false);
    //   }
    // };
    // fetchData();
    // handleFilter();
  }, []);

  const loadDefaultData = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_ACCESS_EMPLOYEE_DATA}V2`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const json = await res.json();
      setData(json.data || []);
    } catch (error) {
      console.error("Error loading default data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const noFiltersApplied =
      !selectedEmployee &&
      !selectedAccessType &&
      !selectedRole &&
      !selectedStatus;

    if (noFiltersApplied) {
      loadDefaultData(); // fetch V2 without filters
    }
  }, [selectedEmployee, selectedAccessType, selectedRole, selectedStatus]);

  const handleExport = async () => {
    setLoadingExport(true);
    try {
      const params = new URLSearchParams();

      if (selectedStatus) params.append("status", selectedStatus);
      if (selectedEmployee) params.append("employeeId", selectedEmployee.value);
      if (selectedAccessType)
        params.append("accessType", selectedAccessType.value);
      if (selectedRole) params.append("userRole", selectedRole.value);

      const url = `${API_DOWNLOAD_ACCESS_REPORT}?${params.toString()}`;

      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!res.ok) {
        const err = await res.json();
        toast.error(err.message || "Failed to download report");
        return;
      }

      const blob = await res.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = downloadUrl;
      link.download = "Access_Report.xlsx";
      document.body.appendChild(link);

      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setLoadingExport(false);
    }
  };
  const showRole = selectedAccessType?.isRole === 1;

  return (
    <div className="wrapper-body">
      {loadingEmployees && (
        <div className="overlay">
          <div className="mt-5">
            <TailSpin
              height="100"
              width="100"
              radius="1"
              color="blue"
              ariaLabel="tail-spin-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        </div>
      )}
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <PageTitle title={title} description={description} />
      </div>

      <div className="filters d-flex gap-2 mb-3">
        <div className="filter">
          <label className="label">Employee Name</label>
          <Select
            className="pr"
            options={employees}
            placeholder="Select Employee Name"
            value={selectedEmployee}
            onChange={(opt) => setSelectedEmployee(opt)}
            isClearable
          />
        </div>

        <div className="filter">
          <label className="label">Access Type</label>
          <Select
            className="pr"
            options={accessTypes}
            placeholder="Select Access Type"
            value={selectedAccessType}
            onChange={(opt) => setSelectedAccessType(opt)}
            isClearable
          />
        </div>

        {showRole && (
          <div className="filter">
            <label className="label">Role</label>
            <Select
              className="pr"
              options={roles}
              placeholder="Select Role"
              value={selectedRole}
              onChange={(opt) => setSelectedRole(opt)}
              isClearable
            />
          </div>
        )}

        <div className="filter">
          <label className="label">Status</label>
          <Select
            className="col-md-12 col-sm-12 pr"
            classNamePrefix="react-select"
            options={statusOptions}
            value={
              statusOptions.find((s) => s.value === selectedStatus) || null
            }
            onChange={(option) =>
              setSelectedStatus(option ? option.value : null)
            }
            placeholder="Select Status"
            isClearable
          />
        </div>

        <button
          className="theme-button"
          onClick={handleFilter}
          style={{ marginLeft: "auto" }}
        >
          Filter
        </button>

        <button
          className="theme-button"
          onClick={handleExport}
          disabled={loadingExport}
        >
          {loadingExport ? (
            <ThreeDots height="20" width="40" radius="3" color="white" />
          ) : (
            "Download"
          )}
        </button>
      </div>

      {/* TABLE SECTION */}
      {loadingEmployees ? null : loading ? (
        <div className="centered-loader">
          <ThreeDots height="100" width="100" radius="9" color="blue" />
        </div>
      ) : data.length === 0 ? (
        <NoRecordsAvailable />
      ) : (
        <div className="card p-3 mt-3">
          <SortableTable
            columns={columns}
            data={data}
            currentPage={1}
            limit={10}
          />
        </div>
      )}
    </div>
  );
};

export default DownloadAccessReport;
